import { useIntl } from "react-intl";

/* eslint-disable jsx-a11y/anchor-is-valid */
export function Drop() {
  const intl = useIntl();
  return (
    <div
      className="menu menu-sub menu-sub-dropdown w-250px w-md-300px"
      data-kt-menu="true"
    >
      <div className="px-7 py-5">
        <div className="fs-5 text-dark fw-bolder">
          {" "}
          {intl.formatMessage({
            id: "MENU.DASHBOARD_PLANS_SALES.FILTERS",
          })}
        </div>
      </div>

      <div className="separator border-gray-200"></div>

      <div className="px-7 py-5">
        <div className="mb-10">
          <label className="form-label fw-bold">
            {intl.formatMessage({
              id: "MENU.DASHBOARD_PLANS_SALES.STATUS",
            })}
            :
          </label>

          <div>
            <select
              className="form-select form-select-solid"
              data-kt-select2="true"
              data-placeholder="Select option"
              data-allow-clear="true"
              defaultValue={"1"}
            >
              <option></option>
              <option value="1">
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.YEAR",
                })}
              </option>
              <option value="2">
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.MONTH",
                })}
              </option>
              <option value="3">
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.WEEK",
                })}
              </option>
              <option value="4">
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.TOTAL",
                })}
              </option>
            </select>
          </div>
        </div>

        <div className="mb-10">
          <label className="form-label fw-bold">
            {" "}
            {intl.formatMessage({
              id: "MENU.DASHBOARD_SALES.SELECT_SELLER",
            })}
          </label>

          <div className="d-flex">
            <label className="form-check form-check-sm form-check-custom form-check-solid me-5">
              <input className="form-check-input" type="checkbox" value="1" />
              <span className="form-check-label">Liandra</span>
            </label>

            <label className="form-check form-check-sm form-check-custom form-check-solid">
              <input className="form-check-input" type="checkbox" value="2" />
              <span className="form-check-label">Darla</span>
            </label>
          </div>
        </div>

        <div className="mb-10">
          <label className="form-label fw-bold">
            {intl.formatMessage({
              id: "MENU.DASHBOARD_PLANS_SALES.NOTIFICATION_SALLES",
            })}
          </label>

          <div className="form-check form-switch form-switch-sm form-check-custom form-check-solid">
            <input
              className="form-check-input"
              type="checkbox"
              value=""
              name="notifications"
              defaultChecked={true}
            />
            <label className="form-check-label">
              {intl.formatMessage({
                id: "MENU.DASHBOARD_PLANS_SALES.ACTIVE",
              })}
            </label>
          </div>
        </div>

        <div className="d-flex justify-content-end">
          <button
            type="reset"
            className="btn btn-sm btn-light btn-active-light-primary me-2"
            data-kt-menu-dismiss="true"
          >
            {intl.formatMessage({
              id: "MENU.DASHBOARD_PLANS_SALES.DEFAULT_RESTART",
            })}
          </button>

          <button
            type="submit"
            className="btn btn-sm btn-primary"
            data-kt-menu-dismiss="true"
          >
            {intl.formatMessage({
              id: "MENU.DASHBOARD_PLANS_SALES.APPLY",
            })}
          </button>
        </div>
      </div>
    </div>
  );
}
